var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mit_bl._Kreislinie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009fe3;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{stroke:#009fe3;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gl\\xFChbirne"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 75,
    cy: 75,
    r: 68.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.32,90.51h-15.04c-1.12,0-2.03.89-2.03,1.99s.91,1.99,2.03,1.99h15.04c1.12,0,2.03-.89,2.03-1.99s-.91-1.99-2.03-1.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.86,102.24v1.08c0,1.22,1.01,2.21,2.26,2.21h3.37c1.25,0,2.26-.99,2.26-2.21v-1.08c2.55-.18,4.58-2.24,4.58-4.79h-17.04c0,2.55,2.02,4.61,4.58,4.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.84,52.86c-7.21,0-13.08,5.75-13.08,12.81,0,1.1-.91,1.99-2.03,1.99s-2.03-.89-2.03-1.99c0-9.25,7.69-16.78,17.13-16.78,1.12,0,2.03.89,2.03,1.99s-.91,1.99-2.03,1.99m-.03-6.9c-11.22,0-20.32,8.91-20.32,19.9,0,4.64,1.63,8.9,4.35,12.28,2.41,2.99,4.69,6.25,6.65,9.54h18.63c1.99-3.32,4.23-6.52,6.65-9.54,2.72-3.38,4.35-7.64,4.35-12.27,0-10.99-9.1-19.9-20.32-19.9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.36ff9be745140b80056b7148554372b5.svg";
export { ForwardRef as ReactComponent };